let pushErrorFunc = null

export function registerErrorHandler(func) { pushErrorFunc = func }

export function handleError(message) {
    if (pushErrorFunc) pushErrorFunc(message)
}

// Extract a displayable string from an axios error. The backend exception filter wraps every body as
// { statusCode, message: <inner> }, where <inner> is often itself an object ({ message, code } for our
// AI errors, or { statusCode, message, error } for 404s/validation). Unwrap one level and fall back so
// callers never put a non-string (an object or array) into React state and crash the render.
export function errMessage(e, fallback = "Something went wrong. Please try again.") {
    let m = e?.response?.data?.message
    if (m && typeof m === "object" && !Array.isArray(m)) m = m.message ?? m.error
    if (Array.isArray(m)) m = m[0]
    return typeof m === "string" && m.trim() ? m : fallback
}